module.exports = __webpack_public_path__ + "static/media/bg.34f09239.svg";